import { ErrorBlock } from "mta-rkvr-styles";
import React from "react";
import { useTranslation } from "react-i18next";
import * as dayjs from "dayjs";

export const ErrorPage: React.FC<{
  errorContainer:
    | { code?: number | string; timestamp?: string; request?: string; uniquecode?: string; queryContext?: string }[]
    | undefined;
  backFn: Function;
}> = ({ errorContainer, backFn }) => {
  const { t } = useTranslation();
  const tBase = "errorPage.";
  const errorArray: any[] = [];

  function formatTimeToStr(timestamp: string, outputFormat: string) {
    const date = new Date(timestamp);
    return dayjs.default(date).format(outputFormat);
  }

  errorArray.push(t(tBase + "errpageTitle"));
  if (errorContainer != undefined) {
    const { code } = errorContainer[0];
    const codeSpecific = code != undefined;

    if (codeSpecific) {
      if (code == 404) {
        errorArray.push(t(tBase + "codes.noPageFound"));
      } else if (code == 403) {
        errorArray.push(t(tBase + "codes.forbidden"));
      } else if (code == 500) {
        errorArray.push(t(tBase + "codes.internalError"));
      } else if (code == "timeout") {
        errorArray.push(t(tBase + "codes.fetchTimeout"));
      } else if (code == "abort") {
        errorArray.push(t(tBase + "codes.fetchAbort"));
      } else if (code == "type") {
        errorArray.push(t(tBase + "codes.fetchType"));
      } else if (code == "general") {
        errorArray.push(t(tBase + "codes.fetchGeneral"));
      } else if (code == 502) {
        errorArray.push(t(tBase + "codes.gatewayTimeout"));
      } else if (code == 503) {
        errorArray.push(t(tBase + "codes.serviceUnavailable"));
      } else if (code?.toString().startsWith("50")) {
        errorArray.push(t(tBase + "codes.5xerror"));
      } else {
        errorArray.push(code + " " + t(tBase + "codes.5xerror"));
      }
    }
  }

  errorContainer?.map((errC) => {
    const { code, timestamp, request, uniquecode, queryContext } = errC;
    const codeSpecific = code != undefined;
    const time = timestamp && formatTimeToStr(timestamp, "DD.MM.YYYY HH:mm");
    if (codeSpecific) {
      if (request) {
        errorArray.push(
          <div style={{ position: "relative", left: "10px" }}> {t(tBase + "errRequest") + request} </div>,
        );
      }
      if (queryContext) {
        errorArray.push(
          <div style={{ position: "relative", left: "10px" }}> {t(tBase + "errContext") + queryContext} </div>,
        );
      }
      if (code && uniquecode != "ERR-FETCH") {
        errorArray.push(
          <div style={{ position: "relative", left: "10px" }}> {t(tBase + "errHttpCode") + code} </div>,
        );
      }
      if (uniquecode) {
        errorArray.push(
          <div style={{ position: "relative", left: "10px" }}> {t(tBase + "errUniqueCode") + uniquecode} </div>,
        );
      }
      if (timestamp) {
        errorArray.push(<div style={{ position: "relative", left: "10px" }}> {t(tBase + "errAt") + time} </div>);
      }
    }
    errorArray.push(<p></p>);
  });
  errorArray.push(<a onClick={() => backFn()}>{t(tBase + "back")}</a>);
  return <ErrorBlock messages={errorArray}></ErrorBlock>;
};
